import { ColumnConditionValue } from '@makyoapp/makyo-common'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useCompTableData } from '@/hooks/__project__/useCompTableData'
import { ComponentSettingKey } from '@/shared/builder'
import { getSafely } from '@/shared/safely'

import { CompChartBarWrapperCore } from '../core/charts/bar-chart/wrapper'

/**
 * CompChartBarWrapper
 */
const CompChartBarWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // table data
  const { dbClient, tablesMap } = useDbClientContext()
  const tableId = getSafely(compContext.settings, [ComponentSettingKey.BarChartDataSource], '')
  const dbTable = tableId ? tablesMap.get(tableId) : undefined

  // access table data
  const maxItems = getSafely(compContext.settings, [ComponentSettingKey.BarChartDataItemsPerPage], 10)
  const filterSetting = compContext.settings[ComponentSettingKey.BarChartDataFilter] as ColumnConditionValue
  const sortBy = compContext.settings[ComponentSettingKey.BarChartDataSortBy] as string
  const sortType = compContext.settings[ComponentSettingKey.BarChartDataSortType] as string

  const [{ rows }] = useCompTableData({
    table: dbTable,
    componentId: compContext.component._id,
    pagination: { page: 0, perPage: maxItems },
    filterSetting,
    sortSetting: { sortType, sortBy },
  })

  if (!dbTable || !dbClient) return null

  return <CompChartBarWrapperCore infos={infosProps} tableData={{ tableId, dbTable, dbClient, rows }} />
}

export default CompChartBarWrapper
